import { create } from "zustand";
import { persist } from "zustand/middleware";

export type ColumnProfileId = "default" | "custom1" | "custom2";

export const CUSTOM_PROFILE_IDS = ["custom1", "custom2"] as const;
export type CustomProfileId = (typeof CUSTOM_PROFILE_IDS)[number];

interface ColumnProfilesStore {
  activeProfile: ColumnProfileId;
  // `null` means the profile has not been customized yet and should show all columns.
  customProfiles: Record<CustomProfileId, string[] | null>;
  // Whether list-type columns are truncated to a few items for each custom profile.
  customConcise: Record<CustomProfileId, boolean>;
  setActiveProfile: (id: ColumnProfileId) => void;
  saveCustomProfile: (
    id: CustomProfileId,
    columns: string[],
    conciseView: boolean,
  ) => void;
}

export const useColumnProfilesStore = create<ColumnProfilesStore>()(
  persist(
    (set) => ({
      activeProfile: "default",
      customProfiles: { custom1: null, custom2: null },
      customConcise: { custom1: false, custom2: false },
      setActiveProfile: (id) => set({ activeProfile: id }),
      saveCustomProfile: (id, columns, conciseView) =>
        set((state) => ({
          customProfiles: { ...state.customProfiles, [id]: columns },
          customConcise: { ...state.customConcise, [id]: conciseView },
        })),
    }),
    {
      name: "fuse-bart-portal.column-profiles",
    },
  ),
);
